import apiAxios from "@/config/apiAxios";
export default {
    getVegaConfig( path ){
        return new Promise( (resolve, reject) => {
            apiAxios.get( `${config.serverUrl}/cmnd/ndisk/ms/v1/file_preview/${path}`, { 'contentType' : 'application/octet-stream' }, _r => {
                if( _r?.code && _r.code != 200 )
                    reject( false );
                else
                    resolve( _r );
            } )
        } )
        // return Promise.resolve( {
        //     "$schema": "https://vega.github.io/schema/vega/v5.json",
        //     "width": 1240,
        //     "height": 111,
        //     "padding": {
        //         "left": 5,
        //         "right": 5,
        //         "top": 20,
        //         "bottom": 0
        //     },
        //     "autosize": "none",
        //     "signals": [
        //         {
        //             "name": "cx",
        //             "update": "width / 2"
        //         },
        //         {
        //             "name": "cy",
        //             "update": "height / 2"
        //         },
        //         {
        //             "name": "gravityX",
        //             "value": 0.2
        //         },
        //         {
        //             "name": "gravityY",
        //             "value": 0.8
        //         }
        //     ],
        //     "data": [
        //         {
        //             "name": "table",
        //             "values": [
        //                 {
        //                     "fid": "2fb86cac97e85e56712bb8059a27fde2",
        //                     "path": "usys/products/release/1645603074312183810_sbom.json",
        //                     "author": "张三",
        //                     "name": "数据订阅测试产品01",
        //                     "ctime": "2023-04-11 09:42:34",
        //                     "pid": "1645603074312183810",
        //                     "_id": "1645603214951092226",
        //                     "type": "products",
        //                     "tips": {
        //                         "formData": {
        //                             "prodName": {
        //                                 "label": "产品名称",
        //                                 "value": "数据订阅测试产品01"
        //                             }
        //                         }
        //                     },
        //                     "tags": {
        //                         "prod_category_brain_method": true,
        //                         "scene_oppty": true,
        //                         "tech_sbom": true,
        //                         "origin_1645603074312183810": true,
        //                         "tech_rpt": true
        //                     },
        //                     "desc": "",
        //                     "category": "数据订阅测试产品01",
        //                     "amount": 0.8
        //                 }
        //             ]
        //         }
        //     ],
        //     "scales": [
        //         {
        //             "name": "size",
        //             "domain": {
        //                 "data": "table",
        //                 "field": "amount"
        //             },
        //             "range": [
        //                 100,
        //                 3000
        //             ]
        //         },
        //         {
        //             "name": "color",
        //             "type": "ordinal",
        //             "domain": {
        //                 "data": "table",
        //                 "field": "category"
        //             },
        //             "range": {
        //                 "scheme": "blues"
        //             }
        //         }
        //     ],
        //     "marks": [
        //         {
        //             "name": "nodes",
        //             "type": "symbol",
        //             "from": {
        //                 "data": "table"
        //             },
        //             "encode": {
        //                 "enter": {
        //                     "fill": {
        //                         "scale": "color",
        //                         "field": "category"
        //                     },
        //                     "xfocus": {
        //                         "signal": "cx"
        //                     },
        //                     "yfocus": {
        //                         "signal": "cy"
        //                     }
        //                 },
        //                 "update": {
        //                     "size": {
        //                         "signal": "pow(2 * datum.amount, 2)",
        //                         "scale": "size"
        //                     },
        //                     "stroke": {
        //                         "value": "white"
        //                     },
        //                     "strokeWidth": {
        //                         "value": 1
        //                     },
        //                     "tooltip": {
        //                         "signal": "datum"
        //                     }
        //                 }
        //             },
        //             "transform": [
        //                 {
        //                     "type": "force",
        //                     "iterations": 100,
        //                     "static": false,
        //                     "forces": [
        //                         {
        //                             "force": "collide",
        //                             "iterations": 2,
        //                             "radius": {
        //                                 "expr": "sqrt(datum.size) / 1.8"
        //                             }
        //                         },
        //                         {
        //                             "force": "center",
        //                             "x": {
        //                                 "signal": "cx"
        //                             },
        //                             "y": {
        //                                 "signal": "cy"
        //                             }
        //                         },
        //                         {
        //                             "force": "x",
        //                             "x": "xfocus",
        //                             "strength": {
        //                                 "signal": "gravityX"
        //                             }
        //                         },
        //                         {
        //                             "force": "y",
        //                             "y": "yfocus",
        //                             "strength": {
        //                                 "signal": "gravityY"
        //                             }
        //                         }
        //                     ]
        //                 }
        //             ]
        //         },
        //         {
        //             "type": "text",
        //             "from": {
        //                 "data": "nodes"
        //             },
        //             "encode": {
        //                 "enter": {
        //                     "dx": {
        //                         "value": 0
        //                     },
        //                     "align": {
        //                         "value": "center"
        //                     },
        //                     "baseline": {
        //                         "value": "middle"
        //                     },
        //                     "fontSize": {
        //                         "value": 12
        //                     },
        //                     "fill": {
        //                         "value": "black"
        //                     },
        //                     "text": {
        //                         "field": "datum.category"
        //                     },
        //                     "limit": {
        //                         "value": 80
        //                     }
        //                 },
        //                 "update": {
        //                     "x": {
        //                         "field": "x"
        //                     },
        //                     "y": {
        //                         "field": "y"
        //                     }
        //                 }
        //             }
        //         }
        //     ]
        // } );
    }
}
